class PageNavigation {
    constructor(pageNavigation) {
        const submenuTogglers = [...pageNavigation.querySelectorAll('.page-navigation__submenu-button')];
        const mobileExpander = pageNavigation.querySelector('.page-navigation__menu-expander');
        const mobileExpanderIcon = pageNavigation.querySelector('.page-navigation__menu-expander i');
        const expandableSubMenus = [...pageNavigation.querySelectorAll('.page-navigation__list--submenu')];

        expandableSubMenus.forEach((item) => {
            const isExpanded = item.classList.contains('page-navigation__list--submenu-expanded');

            if (!isExpanded) {
                item.classList.add('page-navigation__list--submenu-expanded');
                item.dataset.height = item.offsetHeight;
                item.classList.remove('page-navigation__list--submenu-expanded');

                item.style.height = `0px`
            }
            else {
                item.dataset.height = item.offsetHeight;
                item.style.height = `${item.offsetHeight}px`
            }
        });

        // Reset
        pageNavigation.classList.remove('page-navigation--loading');
        pageNavigation.classList.remove('page-navigation--expanded');

        if (mobileExpander) {
            mobileExpander.addEventListener('click', (e) => {
                pageNavigation.classList.toggle('page-navigation--expanded');
                const hasChevron = mobileExpanderIcon.classList.contains('fa-chevron-down');

                mobileExpanderIcon.classList.replace(
                    hasChevron ? 'fa-chevron-down' : 'fa-minus',
                    hasChevron ? 'fa-minus' : 'fa-chevron-down'
                );
            });
        }

        if (submenuTogglers) {
            submenuTogglers.map((button) => {
                button.addEventListener('click', (e) => {
                    const isExpanding = !e.target.classList.contains('page-navigation__submenu-button--expanded');

                    e.target.classList.toggle('page-navigation__submenu-button--expanded');
                    const menuList = e.target.nextElementSibling;
                    menuList.classList.toggle('page-navigation__list--submenu-expanded');
                    menuList.style.height = isExpanding ? `${menuList.dataset.height}px` : '0px'
                });
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    var pageNavigations = [...document.querySelectorAll('.page-navigation')];

    if (pageNavigations) {
        pageNavigations.forEach((pageNavigation) => {
            new PageNavigation(pageNavigation);
        });
    }
});